import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import ReactToPrint from 'react-to-print';
import EtiquetaCassetePrintContainer from './etiqueta.print.container';
import * as acessos from '../../../../../../acessos.const.util';
import IntlMessage from "../../../../../../helpers/intlMessage";

const EtiquetaMacroscopiaPage = (props) => (
  <div>
    <Row>
      <Col>
        <FormGroup className='ml1-25rem'>
          <i className={props.all ? 'far fa-check-square' : 'far fa-square'}>
            {' '}
          </i>
          <Label className='checkbox-all' check onClick={props.onClickAll}>
            <IntlMessage id = "dashboards.examDetail.selectAll"/>
          </Label>
        </FormGroup>
      </Col>
      {props.acessoPermitido(props.usuario, acessos.Etiqueta) &&
        props.acessoPermitido(props.usuario, acessos.Imprimir) && (
          <Col sm={{ size: 'auto', offset: 1 }}>
            <FormGroup>
              <ReactToPrint
                trigger={() => <a className='mv-basico-imprimir'>&nbsp;</a>}
                content={() => this.componentRef}
                onBeforePrint={() => {
                  props.loading(true);
                }}
                onAfterPrint={() => {
                  props.loading(false);
                }}
              />
            </FormGroup>
          </Col>
        )}
    </Row>
    {props.blocos.map((bloco) => {
      return (
        <Row key={bloco.id}>
          <Col>
            <Card
              onClick={() => {
                props.onClick(bloco.id);
              }}
            >
              <Row>
                <Col sm='1'>
                  <CardBody className='checkbox'>
                    <i
                      className={
                        props.selecionados.indexOf(bloco.id) === -1
                          ? 'far fa-square'
                          : 'far fa-check-square'
                      }
                    ></i>
                  </CardBody>
                </Col>
                <Col>
                  <CardBody>
                    <CardTitle>{bloco.numeroBloco}</CardTitle>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      );
    })}
    <div style={{ display: 'none' }}>
      <EtiquetaCassetePrintContainer
        ref={(el) => (this.componentRef = el)}
        nrExame={props.detalhes.nrExame}
        selecionados={props.selecionados}
        blocos={props.blocos}
      />
    </div>
  </div>
);

export default EtiquetaMacroscopiaPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/etiqueta/etiqueta.page.js